import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import GetPaymentListRequest from '@/api/payments/get-payment-list.request';
import { GetModerationActionListRequest } from '@/api/payments/get-moderation-action-list.request';
import {
  UpdateProcessingModeratedTransactionManualFlowRequest,
} from '@/api/payments/update-processing-moderated-transaction-manual-flow.request';
import {
  UpdateProcessingModeratedTransactionForceTakeRequest,
} from '@/api/payments/update-processing-moderated-transaction-force-take.request';
import {
  UpdateProcessingModeratedTransactionRequest,
} from '@/api/payments/update-processing-moderated-transaction.request';

export class PaymentsApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) {}

  public get getPaymentListRequest(): GetPaymentListRequest {
    return new GetPaymentListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }

  public get getModerationActionListRequest(): GetModerationActionListRequest {
    return new GetModerationActionListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }

  public get updateProcessingModeratedTransactionManualFlowRequest():
  UpdateProcessingModeratedTransactionManualFlowRequest {
    return new UpdateProcessingModeratedTransactionManualFlowRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.PUT,
    );
  }

  public get updateProcessingModeratedTransactionForceTakeRequest():
  UpdateProcessingModeratedTransactionForceTakeRequest {
    return new UpdateProcessingModeratedTransactionForceTakeRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.PUT,
    );
  }

  public get updateProcessingModeratedTransactionRequest(): UpdateProcessingModeratedTransactionRequest {
    return new UpdateProcessingModeratedTransactionRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.PUT,
    );
  }
}
